import { JRCInputCheckbox } from 'components/Form/Input/JRCInputCheckbox/JRCInputCheckbox';

import React from 'react';
import { useForm } from 'react-hook-form';
import styled from 'styled-components';

export const CSSInputWrapper = styled.div`
    & > fieldset {
        margin: 0px;
    }
    input {
        margin: 0;
    }
`;

export const EditorInputCheckbox = ({
    label,
    initialValue,
    options,
    onChange,
}: {
    label: string;
    initialValue: string[];
    options: { label: string; value: string }[];
    onChange: (value: string[]) => void;
}) => {
    const { control, watch, setValue } = useForm({
        defaultValues: {
            checkbox: initialValue ?? [],
        },
        criteriaMode: 'all',
    });

    React.useEffect(() => {
        setValue('checkbox', initialValue);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialValue]);

    React.useEffect(() => {
        const subscription = watch((data: any) => {
            onChange(data.checkbox);
        });
        return () => subscription.unsubscribe();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [watch, onChange]);

    return <JRCInputCheckbox name={'checkbox'} label={label} options={options} control={control as any} />;
};
